import { gql } from '@apollo/client';

export const getAgendaUser = gql /* GraphQL */ `
query GetAgendaUser($userId: ID!) {
  getAgendaUser(userId: $userId) {
    com {
      comId
      name
    }
    comId
    createdAt
    email
    firstName
    isConfirmed
    language
    lastName
    password
    phoneNumber
    profileOwner
    role
    image
    suspended
    type
    updatedAt
    userId
    username
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
    sunday
    night
    hours
    timezone
    __typename
  }
}
`;

export const usersByUsername = gql/* GraphQL */ `
query UsersByUsername(
  $filter: ModelAgendaUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $username: String!
) {
  usersByUsername(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    username: $username
  ) {
    items {
      comId
      userId
      username
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const updateAgendaUser = gql/* GraphQL */ `
mutation UpdateAgendaUser(
  $condition: ModelAgendaUserConditionInput
  $input: UpdateAgendaUserInput!
) {
  updateAgendaUser(condition: $condition, input: $input) {
    comId
    createdAt
    email
    firstName
    isConfirmed
    language
    lastName
    password
    phoneNumber
    profileOwner
    image
    role
    suspended
    type
    updatedAt
    userId
    username
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
    sunday
    night
    hours
    timezone
    __typename
  }
}
`;

// export const deleteAgendaUser = gql /* GraphQL */ `
// mutation DeleteAgendaUser(
//   $condition: ModelAgendaUserConditionInput
//   $input: DeleteAgendaUserInput!
// ) {
//   deleteAgendaUser(condition: $condition, input: $input) {
//     comId
//     profileOwner
//     role
//     idConfirmed
//     suspended
//     userId
//     username
//     __typename
//   }
// }
// `;